<template>
    <rkm-area
        background-color="secondary"
        closed
        header-prefix-icon="check-circle"
        title="Finalização do atendimento"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <small>Tempo de atendimento na unidade: <strong>{{ item.tempoAtendimentoUnidade }}</strong></small>
            </rkm-col>
            <rkm-col cols="12">
                <small>Tempo de atendimento: <strong>{{ item.tempoAtendimento }}</strong></small>
            </rkm-col>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.finalizacao.atendimentoTipo.nome"
                    label="Tipo de atendimento"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.isAtendimentoSaudeBucal">
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.saudeBucal.consultaTipo.descricao"
                    label="Tipo de consulta"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.finalizacao.atendimentoCompartilhadoUsuario.cns
                        ? `${item.finalizacao.atendimentoCompartilhadoUsuario.nome} - ${item.finalizacao.atendimentoCompartilhadoUsuario.cns}`
                        : item.finalizacao.atendimentoCompartilhadoUsuario.nome"
                    label="Atendimento compartilhado"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.isAtendimentoSaudeBucal">
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.saudeBucal.fornecimentos.join(', ')"
                    label="Fornecimento"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxProcedimentoAdministrativo :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxCasoSuspeito :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-3">
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.finalizacao.racionalidadeSaude.descricao"
                    label="Racionalidade em saúde (Exceto alopatia/convencional)"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.finalizacao.condutas.join(', ')"
                    label="Condutas"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.finalizacao.equipe.descricao"
                    label="Equipe"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <Item
                    :get-value="() => item.finalizacao.turno.nome"
                    label="Turno"
                />
            </rkm-col>

            <rkm-col cols="6">
                <Item
                    :get-value="() => item.finalizacao.atencaoBasicaLocalAtendimento.descricao"
                    label="Local de atendimento"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12" v-if="item.finalizacao.emadTipoAtendimento && item.finalizacao.emadModalidade">

                <rkm-area
                    title="Atendimento domiciliar - EMAD"
                >
                    <rkm-row>
                        <rkm-col cols="4">
                            <Item
                                :get-value="() => item.finalizacao.emadTipoAtendimento"
                                label="Tipo de atendimento"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <Item
                                :get-value="() => item.finalizacao.emadModalidade"
                                label="Modalidade"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <Item
                                :get-value="() => item.finalizacao.emadCondutaDesfecho"
                                label="Conduta/Desfecho"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12" v-if="item.finalizacao.emadProcedencia && item.finalizacao.emadCuidador">

                <rkm-area
                    title="Avaliaçăo de Elegibilidade e admissăo - EMAD"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.finalizacao.emadProcedencia"
                                label="Procedência"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.finalizacao.emadCidPrimario
                                    ? `${item.finalizacao.emadCidPrimario.codigo} - ${item.finalizacao.emadCidPrimario.nome}`
                                    : null"
                                label="CID Primário"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.finalizacao.emadCuidador"
                                label="Cuidador"
                            />
                        </rkm-col>

                        <rkm-col cols="6" v-if="item.finalizacao.emadCnsCuidador">
                            <Item
                                :get-value="() => item.finalizacao.emadCnsCuidador"
                                label="CNS do cuidador"
                            />
                        </rkm-col>

                        <rkm-col cols="6" v-if="item.finalizacao.emadCpfCuidador">
                            <Item
                                :get-value="() => item.finalizacao.emadCpfCuidador"
                                label="CPF do cuidador"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.finalizacao.emadConclusao"
                                label="Conclusão"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.finalizacao.emadJustificativa"
                                label="Justificativa"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">

                <rkm-area
                    title="Desfecho"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.finalizacao.desfecho"
                                label="Desfecho"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

                <rkm-row>
            <rkm-col cols="12">

                <rkm-area
                    title="Tempo Atendimento"
                >
                    <rkm-row>
                        <rkm-col cols="12">              
                            <Item
                                :get-value="() => item.tempoAtendimento"   
                                label="Tempo no atendimento"          
                            />

                            <Item
                                :get-value="() => item.tempoAtendimentoUnidade"   
                                label="Tempo na unidade"          
                            />

                            
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
        
    </rkm-area>
</template>

<script>
// Components.
import BoxCasoSuspeito from './components/caso-suspeito/Index'
import BoxProcedimentoAdministrativo from './components/procedimento-administrativo/Index'
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {
        BoxCasoSuspeito,
        BoxProcedimentoAdministrativo,
        Item
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>